/**
 * Cueca Absorvente Charmelle, LP "Cueca Monalisa" (prefixo cu-).
 *
 * Responsável por:
 * - Acordeão de perguntas frequentes
 * - Galeria de fotos da tecnologia SoftLayer (setas)
 * - Galeria de fotos do produto na oferta (miniaturas + setas)
 * - Seletor de kit (1 / 3 / 5 / 8 peças), com preço, comparado e desconto reais
 * - Modo avulso: seletor de Tamanho e Cor de uma peça, ligado às variantes reais
 * - Modo kit: personalização por peça (Tamanho e Cor de cada uma), com contador
 *   de progresso e botão de finalizar que só habilita quando todas as peças
 *   estão escolhidas
 * - Envio real para o carrinho via /cart/add.js (um item por peça no modo kit,
 *   a peça única no modo avulso), aproveitando os descontos automáticos por
 *   quantidade já configurados na Shopify
 * - Barra fixa de compra no mobile, com preço sincronizado ao kit escolhido
 */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    value = parts.join(',');
    if (format) {
      return format.replace('{{amount}}', value);
    }
    return 'R$ ' + value;
  }

  /* ---------------- FAQ ---------------- */

  function initFaq(root) {
    var items = root.querySelectorAll('[data-cu-faq-item]');
    items.forEach(function (item) {
      var question = item.querySelector('[data-cu-faq-question]');
      if (!question) return;
      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('cu-is-open');
        items.forEach(function (other) {
          other.classList.remove('cu-is-open');
          var q = other.querySelector('[data-cu-faq-question]');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('cu-is-open');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ---------------- Galeria da seção de tecnologia ---------------- */

  function initTechGallery(root) {
    var gallery = root.querySelector('[data-cu-tech-gallery]');
    if (!gallery) return;
    var prevBtn = root.querySelector('[data-cu-tech-prev]');
    var nextBtn = root.querySelector('[data-cu-tech-next]');

    function step() {
      var photo = gallery.querySelector('.cu-tech__photo');
      var width = photo ? photo.getBoundingClientRect().width + 4 : 300;
      return width;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        gallery.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        gallery.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }
  }

  /* ---------------- Galeria de fotos do produto, na oferta ---------------- */

  function initOfferGallery(root) {
    var thumbsWrap = root.querySelector('[data-cu-gallery-thumbs]');
    if (!thumbsWrap) return;
    var mainImg = root.querySelector('[data-cu-offer-main-img]');
    var thumbs = root.querySelectorAll('[data-cu-gallery-thumb]');
    var prevBtn = root.querySelector('[data-cu-gallery-prev]');
    var nextBtn = root.querySelector('[data-cu-gallery-next]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var fullSrc = thumb.getAttribute('data-full-src');
        if (fullSrc && mainImg && mainImg.tagName === 'IMG') {
          mainImg.src = fullSrc;
        }
        thumbs.forEach(function (t) {
          t.classList.remove('cu-offer__gallery-thumb--selected');
        });
        thumb.classList.add('cu-offer__gallery-thumb--selected');
        thumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      });
    });

    function thumbStep() {
      var first = thumbsWrap.querySelector('[data-cu-gallery-thumb]');
      return first ? first.getBoundingClientRect().width + 8 : 80;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        thumbsWrap.scrollBy({ left: -thumbStep(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        thumbsWrap.scrollBy({ left: thumbStep(), behavior: 'smooth' });
      });
    }
  }

  /* ---------------- Oferta: kit, avulso e personalização ---------------- */

  function initOfferForm(root) {
    var form = root.querySelector('[data-cu-offer-form]');
    if (!form) return;

    var dataScript = root.querySelector('[data-cu-variants-json]');
    if (!dataScript) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    var moneyFormat = form.getAttribute('data-money-format') || 'R$ {{amount}}';

    var priceEl = form.querySelector('[data-cu-offer-price]');
    var compareEl = form.querySelector('[data-cu-offer-compare]');
    var discountEl = form.querySelector('[data-cu-offer-discount]');
    var availabilityEl = form.querySelector('[data-cu-offer-availability]');
    var hiddenIdInput = form.querySelector('[data-cu-single-hidden-id]');
    var submitBtn = form.querySelector('[data-cu-offer-submit]');
    var errorEl = form.querySelector('[data-cu-offer-error]');
    var singleBlock = form.querySelector('[data-cu-single-block]');
    var multiBlock = form.querySelector('[data-cu-multi-block]');
    var counterEl = form.querySelector('[data-cu-personalize-counter]');
    var kitButtons = form.querySelectorAll('[data-cu-kit-btn]');
    var personalizeRows = form.querySelectorAll('[data-cu-personalize-row]');

    var pendingLabel = submitBtn ? submitBtn.textContent.trim() : 'Escolha o tamanho e a cor de cada peça';
    var counterLabel = counterEl ? counterEl.textContent.replace(/\d.*$/, '').trim() : 'Peças personalizadas';

    /* ---- Modo avulso: seletor de Tamanho/Cor ligado às variantes reais ---- */

    var singleSelection = {};
    var singleOptionGroups = singleBlock ? singleBlock.querySelectorAll('[data-cu-option-name]') : [];

    function findVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var matches = true;
        for (var optionName in sel) {
          if (v.options[optionName] !== sel[optionName]) {
            matches = false;
            break;
          }
        }
        if (matches) return v;
      }
      return null;
    }

    singleOptionGroups.forEach(function (group) {
      var optionName = group.getAttribute('data-cu-option-name');
      var buttons = group.querySelectorAll('[data-cu-option-value]');
      buttons.forEach(function (btn, index) {
        if (index === 0 && !singleSelection[optionName]) {
          singleSelection[optionName] = btn.getAttribute('data-cu-option-value');
          btn.setAttribute('aria-pressed', 'true');
        }
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          singleSelection[optionName] = btn.getAttribute('data-cu-option-value');
          syncSingleVariant();
        });
      });
    });

    var singleMatchedVariant = null;

    function syncSingleVariant() {
      singleMatchedVariant = findVariant(singleSelection);
      if (hiddenIdInput && singleMatchedVariant) {
        hiddenIdInput.value = singleMatchedVariant.id;
      }
      updateSubmitState();
    }

    /* ---- Modo kit: personalização por peça ---- */

    var rowSelections = {};

    function rowDone(index) {
      var sel = rowSelections[index];
      if (!sel) return false;
      var names = Object.keys(sel);
      if (names.length === 0) return false;
      for (var i = 0; i < names.length; i++) {
        if (!sel[names[i]]) return false;
      }
      var expectedGroups = personalizeRows[index]
        ? personalizeRows[index].querySelectorAll('[data-cu-row-option-name]').length
        : 0;
      return names.length >= expectedGroups && expectedGroups > 0;
    }

    function setupPersonalizeRow(row) {
      var index = parseInt(row.getAttribute('data-row-index'), 10);
      rowSelections[index] = rowSelections[index] || {};
      var statusEl = row.querySelector('[data-cu-row-status]');
      var groups = row.querySelectorAll('[data-cu-row-option-name]');

      groups.forEach(function (group) {
        var optionName = group.getAttribute('data-cu-row-option-name');
        var buttons = group.querySelectorAll('[data-cu-row-option-value]');
        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            buttons.forEach(function (b) {
              b.setAttribute('aria-pressed', 'false');
            });
            btn.setAttribute('aria-pressed', 'true');
            rowSelections[index][optionName] = btn.getAttribute('data-cu-row-option-value');
            refreshRowStatus(row, index, statusEl);
            updateSubmitState();
          });
        });
      });
    }

    function refreshRowStatus(row, index, statusEl) {
      var done = rowDone(index);
      if (statusEl) {
        statusEl.textContent = done ? 'Pronto' : 'Falta escolher';
        statusEl.classList.toggle('cu-personalize__status--done', done);
      }
    }

    personalizeRows.forEach(function (row) {
      setupPersonalizeRow(row);
    });

    function resetPersonalizeSelections() {
      rowSelections = {};
      personalizeRows.forEach(function (row) {
        var index = parseInt(row.getAttribute('data-row-index'), 10);
        rowSelections[index] = {};
        var statusEl = row.querySelector('[data-cu-row-status]');
        if (statusEl) {
          statusEl.textContent = 'Falta escolher';
          statusEl.classList.remove('cu-personalize__status--done');
        }
        var optBtns = row.querySelectorAll('[data-cu-row-option-value]');
        optBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      });
    }

    function visibleRowCount(qty) {
      var count = 0;
      personalizeRows.forEach(function (row) {
        var index = parseInt(row.getAttribute('data-row-index'), 10);
        if (index < qty) {
          row.hidden = false;
          count++;
        } else {
          row.hidden = true;
        }
      });
      return count;
    }

    function doneRowCount(qty) {
      var count = 0;
      for (var i = 0; i < qty; i++) {
        if (rowDone(i)) count++;
      }
      return count;
    }

    /* ---- Seletor de kit ---- */

    function getSelectedKitBtn() {
      var selected = null;
      kitButtons.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') selected = b;
      });
      return selected || kitButtons[0];
    }

    function applyKitDisplay(btn) {
      if (priceEl) priceEl.textContent = btn.getAttribute('data-cu-kit-price') || '';

      var compareVal = btn.getAttribute('data-cu-kit-compare') || '';
      if (compareEl) {
        if (compareVal) {
          compareEl.textContent = compareVal;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      var discountVal = btn.getAttribute('data-cu-kit-discount') || '';
      if (discountEl) {
        if (discountVal) {
          discountEl.textContent = discountVal;
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
    }

    function pickKit(btn) {
      kitButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
      applyKitDisplay(btn);

      var qty = parseInt(btn.getAttribute('data-cu-kit-qty'), 10) || 1;

      if (qty === 1) {
        if (singleBlock) singleBlock.hidden = false;
        if (multiBlock) multiBlock.hidden = true;
        syncSingleVariant();
      } else {
        if (singleBlock) singleBlock.hidden = true;
        if (multiBlock) multiBlock.hidden = false;
        resetPersonalizeSelections();
        visibleRowCount(qty);
        if (counterEl) counterEl.textContent = counterLabel + ': 0 / ' + qty;
      }

      updateSubmitState();
    }

    kitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pickKit(btn);
      });
    });

    /* ---- Estado do botão de finalizar ---- */

    function updateSubmitState() {
      var kitBtn = getSelectedKitBtn();
      var qty = parseInt(kitBtn.getAttribute('data-cu-kit-qty'), 10) || 1;
      var enabled;

      if (qty === 1) {
        enabled = !!(singleMatchedVariant && singleMatchedVariant.available);
        if (availabilityEl) {
          if (singleMatchedVariant && singleMatchedVariant.available) {
            availabilityEl.textContent = availabilityEl.getAttribute('data-cu-text-available') || 'Em estoque';
            availabilityEl.classList.add('cu-is-available');
            availabilityEl.classList.remove('cu-is-unavailable');
          } else {
            availabilityEl.textContent = availabilityEl.getAttribute('data-cu-text-unavailable') || 'Combinação indisponível';
            availabilityEl.classList.remove('cu-is-available');
            availabilityEl.classList.add('cu-is-unavailable');
          }
        }
      } else {
        var done = doneRowCount(qty);
        enabled = done === qty;
        if (counterEl) counterEl.textContent = counterLabel + ': ' + done + ' / ' + qty;
        if (availabilityEl) {
          availabilityEl.textContent = availabilityEl.getAttribute('data-cu-text-available') || 'Em estoque';
          availabilityEl.classList.add('cu-is-available');
          availabilityEl.classList.remove('cu-is-unavailable');
        }
      }

      if (submitBtn) {
        if (enabled) {
          submitBtn.textContent = 'Adicionar ao carrinho, ' + (kitBtn.getAttribute('data-cu-kit-price') || '');
          submitBtn.classList.remove('cu-btn-disabled');
          submitBtn.removeAttribute('disabled');
        } else {
          submitBtn.textContent = pendingLabel;
          submitBtn.classList.add('cu-btn-disabled');
          submitBtn.setAttribute('disabled', 'disabled');
        }
      }

      document.dispatchEvent(
        new CustomEvent('cu:offer-price-change', {
          detail: { priceText: kitBtn.getAttribute('data-cu-kit-price') || '' },
        })
      );
    }

    /* ---- Envio real para o carrinho ---- */

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (errorEl) errorEl.textContent = '';

      var kitBtn = getSelectedKitBtn();
      var qty = parseInt(kitBtn.getAttribute('data-cu-kit-qty'), 10) || 1;
      var items = [];

      if (qty === 1) {
        if (!singleMatchedVariant) return;
        items = [{ id: singleMatchedVariant.id, quantity: 1 }];
      } else {
        for (var i = 0; i < qty; i++) {
          var sel = rowSelections[i] || {};
          var variant = findVariant(sel);
          if (!variant) return;
          items.push({ id: variant.id, quantity: 1 });
        }
      }

      if (submitBtn) submitBtn.classList.add('cu-is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error(data && data.description ? data.description : 'Não foi possível adicionar ao carrinho.');
            }
            return data;
          });
        })
        .then(function () {
          if (submitBtn) {
            submitBtn.classList.remove('cu-is-loading');
            submitBtn.classList.add('cu-is-added');
          }
          window.setTimeout(function () {
            window.location.href = '/cart';
          }, 500);
        })
        .catch(function (error) {
          if (submitBtn) submitBtn.classList.remove('cu-is-loading');
          if (errorEl) errorEl.textContent = error.message;
        });
    });

    /* ---- Estado inicial ---- */

    syncSingleVariant();
    updateSubmitState();
  }

  /* ---------------- Barra fixa de compra ---------------- */

  function initStickyBar(root) {
    var bar = root.querySelector('[data-cu-sticky-bar]');
    var hero = document.querySelector('[data-cu-hero]');
    var offer = document.querySelector('[data-cu-offer-section]');
    if (!bar || !hero) return;

    var priceEl = bar.querySelector('[data-cu-sticky-price]');
    var button = bar.querySelector('[data-cu-sticky-button]');

    document.addEventListener('cu:offer-price-change', function (event) {
      if (priceEl && event.detail && event.detail.priceText) {
        priceEl.textContent = event.detail.priceText;
      }
    });

    if (button) {
      button.addEventListener('click', function () {
        var target = document.getElementById('oferta');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    var toggleVisibility = function () {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var pastHero = heroBottom < 0;

      var offerVisible = false;
      if (offer) {
        var rect = offer.getBoundingClientRect();
        offerVisible = rect.top < window.innerHeight && rect.bottom > 0;
      }

      if (pastHero && !offerVisible) {
        bar.classList.add('cu-is-visible');
      } else {
        bar.classList.remove('cu-is-visible');
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
  }

  function init(root) {
    root = root || document;
    initFaq(root);
    initTechGallery(root);
    initOfferGallery(root);
    initOfferForm(root);
    initStickyBar(root);
  }

  onReady(function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
